export default "__VITE_ASSET__tExlvDdK__"